import React from "react";
import { styled } from "@mui/system";
import MuiSkeleton, { SkeletonProps } from "@mui/material/Skeleton";

export interface VaporSkeletonProps extends SkeletonProps {
  /**
   * The animation.
   * If `false` the animation effect is disabled. Based on Vapor Designs it should always be "wave".
   * @default `wave`
   */
  animation?: false | "pulse" | "wave";
  component?: React.ElementType;
}

export const Skeleton: (props: VaporSkeletonProps) => JSX.Element = styled(
  React.forwardRef<HTMLSpanElement, VaporSkeletonProps>((props, ref) => (
    <MuiSkeleton animation="wave" ref={ref} {...props} />
  )),
  {
    name: "Skeleton",
    slot: "Root",
    overridesResolver: (props, styles) => []
  }
)(({ theme }) => ({
  "&.MuiSkeleton-root": {
    background: "rgba(228,234,240,0.64)"
  },
  "&.MuiSkeleton-root::after": {
    background:
      "linear-gradient(90deg, transparent, rgba(201,217,232,0.64), transparent)",
    borderRadius: 2
  }
}));
